<template>
  <h1 class="title has-text-centered is-spaced">
    <go-to-dashboard-button />

    {{ clientsQty }} {{ $t("clients.clients") }}
    <span v-show="!c1 && !c2">&nbsp;</span>

    <br v-show="c1" />

    <button
      class="button"
      @click="$emit('get-clients')"
      :style="c1 ? 'margin-top: 1rem;' : ''"
    >
      <b-icon icon="sync-alt"></b-icon>
    </button>

    <br v-show="c2" />

    <span v-show="!c2">&nbsp;&nbsp;&nbsp;</span>
    &nbsp;
    <span
      style="font-size:1.2rem;position: relative; top: -0.3rem; margin-right: 5px;"
      >{{ $t("clients.history") }}:</span
    >
    <span
      :style="
        c1
          ? 'position: relative; top: -0.1rem;'
          : 'position: relative; top: -1.1rem;'
      "
    >
      <b-field style="display: inline-block;">
        <!-- {{ $t("clients.history") }}: -->
        <b-select
          :placeholder="$t('clients.store')"
          v-model="days"
          @input="$emit('update-days', days)"
        >
          <option value="30">30 {{ $t("clients.days") }}</option>
          <option value="60">60 {{ $t("clients.days") }}</option>
          <option value="90">90 {{ $t("clients.days") }}</option>
        </b-select>
      </b-field>
    </span>

    <b-field style="margin-top: 10px">
      <b-select
        :placeholder="$t('clients.store')"
        class="inline"
        v-model="store"
        @input="$emit('update-store', store)"
      >
        <!-- <option value="">{{ $t("clients.allStores") }}</option> -->
        <option
          v-for="s in orderedStores"
          :key="s._id"
          :value="`${s._id}|${s.storeInfo.name}`"
        >
          {{ s.storeInfo.name }}
        </option>
      </b-select>
    </b-field>

    <hr />
  </h1>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import { responsive } from "../../mixins/responsive";
import goToDashboardButton from "../common/GoToDashboardButton";

export default {
  props: ["clientsQty", "storeId", "storeName"],

  mixins: [common, responsive],

  components: {
    goToDashboardButton
  },

  data() {
    return {
      days: "90",
      store: undefined
    };
  },

  computed: {
    ...mapGetters(["stores", "preferences", "permissions"]),

    c1() {
      return this.windowWidth < 700;
    },

    c2() {
      return this.windowWidth < 370;
    },

    orderedStores() {
      let orderedStores = [];
      if (this.preferences.storesOrder === "alphabetical") {
        orderedStores = [...this.stores].sort((a, b) => {
          return a.storeInfo.name.localeCompare(b.storeInfo.name);
        });
      } else {
        orderedStores = this.stores;
      }
      return orderedStores;
    }
  },

  mounted() {
    if (this.orderedStores.length > 0) {
      this.store = `${this.orderedStores[0]._id}|${this.orderedStores[0].storeInfo.name}`;
      this.$emit("update-store", this.store);
    }
  }
};
</script>

<style scoped>
.inline {
  display: inline;
}
hr {
  background-color: hsl(0, 0%, 71%);
}
</style>
